import type { Dispatch, ReactNode, SetStateAction } from 'react'

import type { CommunityModalType } from '../../types'

export enum CommunityEventType {
  OPEN = 'open',
  CLOSE = 'close'
}

export type CommunityModalContextProps = {
  isOpen: boolean
  setModalType: Dispatch<SetStateAction<CommunityModalType>>
  dispatchModalEvent: (eventType: CommunityEventType) => void
  communityId?: number
  setCommunityId: Dispatch<SetStateAction<number | undefined>>
}

export type CommunityModalProviderProps = {
  children: ReactNode
}

export type CommunityModalEvent = {
  modalType: CommunityModalType
  eventType: CommunityEventType
  communityId?: number
  groupId?: number
}
